module.exports = __webpack_public_path__ + "static/media/users.466dd1bd.svg";